import React, { Fragment, useCallback, useState } from 'react';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
    Input,
    InputGroup,
    InputGroupAddon
} from 'reactstrap';
import { faPhone, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-datepicker';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ModalLogCallEvent(props) {
    const { modalLogCall, toggleModalLogCall, setRefreshNeed } = props;

    const { currentGroup, toggleLoading, setGlobalGift, getGlobalGift, currentScript, setGlobalUpdate } = useAuth();
    const phonePrefix = (currentGroup.hvpn && currentGroup.hvpn === '1') ? '*67' : '';
    const { register, handleSubmit, reset } = useForm({});

    const [logType, setLogType] = useState(false);
    const [date, setDate] = useState(new Date());
    const toggleDate = useCallback(
        (date) => {
            setDate(date);
        },
        [setDate]
    );

    const [needsList, setNeedsList] = useState([]);
    const addNeedItem = useCallback(() => {
        setNeedsList([...needsList, '']);
    }, [setNeedsList, needsList]);
    const changeNeedItem = useCallback((value, index) => {
        const list = [...needsList];
        list[index] = value;
        setNeedsList(list);
    }, [needsList, setNeedsList]);
    const removeNeedItem = useCallback((index) => {
        const list = [...needsList];
        list.splice(index, 1);
        setNeedsList(list);
    }, [needsList, setNeedsList]);

    const stringifyNeedsList = useCallback(() => {
        const list = [...needsList];

        let stringToReturn = '';
        if (list.length === 0) {
            return stringToReturn;
        }

        stringToReturn += 'Reported needs: ';

        list.map((item) => {
            stringToReturn += `'${item}' | `;
            return stringToReturn;
        });

        stringToReturn = stringToReturn.slice(0, stringToReturn.length - 2);

        return stringToReturn;
    }, [needsList]);

    const addNeeds = useCallback(async (receiverId, groupId) => {
        const list = [...needsList];
        if (list.length === 0) {
            return;
        }

        try {
            const promises = list.map(async (item) => {
                if (item && item !== '' && item !== ' ') {
                    await api.post('/ro.team.insertNeed', {
                        receiverId: receiverId,
                        content: item,
                        groupId: groupId,
                    });
                }
            });

            await Promise.all(promises);

            if (setRefreshNeed) {
                setRefreshNeed(true);
            }
    
            toast.success('Needs inserted!');
            setNeedsList([]);
        } catch(err) {
            toast.error('Error on adding Needs');
        }
        
    }, [needsList, setNeedsList, setRefreshNeed]);

    const onSubmitLogCall = useCallback(
        async (data) => {
            if (!data.notes || data.notes === undefined || data.notes === '' || data.notes === ' ') {
                toast.error('Please, insert a note');
                return;
            }

            toggleLoading(true);
            const notes = `${data.notes} - ${stringifyNeedsList()}`;

            const send_data = {
                receiverId: getGlobalGift().receiver.id,
                groupId: currentGroup.id,
                giftId: getGlobalGift().id,
                notes: notes,
            };

            if (logType === true) {
                send_data.date = moment(date).format('YMMDDHHmm')
            } else {
                send_data.date = getGlobalGift().date;
            }

            api.post(`/ro.team.insertLogGift`, send_data)
                .then((response) => {
                    addNeeds(getGlobalGift().receiver.id, currentGroup.id);

                    toast.success(`Log registered!`);
                    toggleModalLogCall();
                    reset(response);
                    setGlobalGift(null);
                    setGlobalUpdate({scheduledGifts: true, toggleModalTargetEvent: true});
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleModalLogCall, reset, currentGroup, date, toggleLoading, setGlobalGift, logType, getGlobalGift, setGlobalUpdate, addNeeds, stringifyNeedsList]
    );

    const convertDateFront = useCallback((date) => {
        const month = parseInt(date.substring(4,6)) - 1;
        const dateObj = new Date(
            date.substring(0,4),
            month,
            date.substring(6,8),
            date.substring(8,10),
            date.substring(10,12),
            0
        );
        return moment(dateObj).format('LLL');
    }, []);

    return (
        <Fragment>
            <Modal isOpen={modalLogCall} toggle={toggleModalLogCall}>
                <ModalHeader toggle={toggleModalLogCall}>
                    Log Call
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup row>
                            <Label for="receiver" sm={2}>
                                Senior
                            </Label>
                            <Col sm={10}>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue={getGlobalGift() && getGlobalGift().receiver.name}
                                    disabled={true}
                                />
                            </Col>
                            
                            {getGlobalGift() && (
                                <Fragment>
                                    <Col sm={2} className="mt-3"></Col>
                                    <Col sm={10} className="mt-3">
                                        Phone:
                                        <InputGroup>
                                            <Input
                                                disabled={true}
                                                value={getGlobalGift().receiver.phone}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <a href={`tel:${phonePrefix}${getGlobalGift().receiver.phone}`} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                                                    <FontAwesomeIcon icon={faPhone} size="1x"/>
                                                </a>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </Col>
                                </Fragment>
                            )}
                            
                        </FormGroup>
                        <FormGroup row>
                            <Label for="date" sm={2}>
                                Date
                            </Label>
                            <Col sm={{size: 9, offset: 1}}>
                                <Label check>
                                    <Input 
                                        type="radio"
                                        checked={!logType}
                                        onChange={() => {
                                            setLogType(!logType);
                                        }}
                                    />
                                        Original Time
                                    </Label>
                            </Col>
                            <Col sm={{size: 10, offset: 2}}>
                                <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    defaultValue={getGlobalGift() && convertDateFront(getGlobalGift().date)}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={2}></Label>
                            <Col sm={{size: 9, offset: 1}}>
                                <Label check>
                                    <Input 
                                        type="radio"
                                        checked={logType}
                                        onChange={() => {
                                            setLogType(!logType);
                                            setDate(new Date());
                                        }}
                                    /> 
                                        Different Time 
                                </Label>
                            </Col>
                            <Col sm={{size: 10, offset: 2}}>
                                <DatePicker
                                    selected={date}
                                    onChange={toggleDate}
                                    showTimeSelect
                                    className="form-control"
                                    timeFormat="p"
                                    timeIntervals={30}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeCaption="Time"
                                    disabled={!logType}
                                    minDate={new Date()}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="script" sm={2}>
                                Script
                            </Label>
                            <Col sm={10}>
                                <textarea
                                    defaultValue={currentScript}
                                    className="form-control"
                                    disabled={true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="notes" sm={2}>
                                Notes
                            </Label>
                            <Col sm={10}>
                                <input
                                    id="notes"
                                    name="notes"
                                    ref={register}
                                    className="form-control"
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={12}>
                                <div className="text-right">
                                    <Button
                                        size="sm"
                                        color="info"
                                        onClick={addNeedItem}
                                    >
                                        Add Need
                                    </Button>
                                </div>
                            </Col>
                        </FormGroup>

                        {needsList.map((item, index) => (
                            <FormGroup row key={index}>
                                <Label for={`needs_${index}`} sm={2}>
                                    Need
                                </Label>
                                <Col sm={10}>
                                    <InputGroup>
                                        <input
                                            id={`needs_${index}`}
                                            name={`needs_${index}`}
                                            className="form-control"
                                            value={item}
                                            placeholder="Insert a Need"
                                            onChange={(e) => {
                                                changeNeedItem(e.target.value, index);
                                            }}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <Button
                                                outline
                                                color="danger"
                                                onClick={() => {
                                                    removeNeedItem(index);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faMinus} size="1x"/>
                                            </Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                        ))}

                        <div className="text-center">
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="success"
                                onClick={handleSubmit(onSubmitLogCall)}
                            >
                                Done
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="danger"
                                onClick={() => {
                                    toggleModalLogCall();
                                    setGlobalGift(null);
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
